// External libraries
import React, { useRef } from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { ErrorIcon } from '@checkout/react-components';
import { useOnMount } from '@/lib/reactHooks';

// Internal modules
import { getContent } from '@/lib';
import { LogInLink } from '../Billing/Components';
import { useMountLogging } from '@/lib/reactHooks';
import { ErrorContainer, ErrorMessage } from './StyledComponents';

export const PageLevelError = (): JSX.Element => {
  useMountLogging('PageLevelError');
  const error = useStoreState(({ ui }) => ui.pageLevelError);
  const { merchant } = useStoreState(({ api }) => api.cartDetails);
  const args = [error];

  if (
    error.includes('accountExistsSignup') ||
    error.includes('emailLinkedToFullAccount')
  ) {
    const logInLink = (
      <LogInLink linkType="link">{getContent('billing.loggingIn')}</LogInLink>
    );
    // @ts-expect-error type args
    args.push({ logInLink });
  }

  if (error.includes('shippingRegionUnsupported')) {
    // @ts-expect-error type args
    args.push({ merchantName: merchant.name });
  }

  // When the page level error is shown, we should auto focus for screen readers
  const errorDivRef = useRef<HTMLDivElement>(null);
  useOnMount(() => {
    if (errorDivRef?.current) {
      errorDivRef.current.focus();
    }
  });

  return (
    <ErrorContainer
      aria-live="polite"
      id="page-level-error-message"
      data-testid="page-level-error-container"
      ref={errorDivRef}
      tabIndex={-1}
    >
      <ErrorIcon />
      <ErrorMessage
        data-error-key={error}
        data-testid="page-level-error-message"
      >
        {getContent(...args)}
      </ErrorMessage>
    </ErrorContainer>
  );
};
